import { render, staticRenderFns } from "./HubSolicitudes.vue?vue&type=template&id=207626c0"
import script from "./HubSolicitudes.vue?vue&type=script&lang=js"
export * from "./HubSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./HubSolicitudes.vue?vue&type=style&index=0&id=207626c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports